import { DuviSharedAdminTestIds } from "@duvi-agency/ui";
import { DuviSharedAdminUserSettings } from "@duvi-agency/auth";
import { DuviCoreAdminAppShell } from "../../components/duvi-core-admin-app-shell";
import { useDuviCoreAdminSettingsPage } from "./use-duvi-core-admin-settings-page";

/**
 * DuviCoreAdminSettingsPage — mounts the shared account-settings surface
 * (@duvi-agency/auth's DuviSharedAdminUserSettings — the rebuilt
 * Details / Security / Appearance tabbed surface from story 27) inside the
 * platform-admin shell. Product-owned data (name, email, sessions) is injected;
 * the auth surface owns the tab UI, its own testids, and the theme-preference
 * wiring. The `settings-page` landmark is emitted here (the shared component
 * makes the consumer responsible for the shell + landmark — bug from story 12
 * that story 13 restored, preserved).
 */
export function DuviCoreAdminSettingsPage() {
  const {
    name,
    email,
    avatarUrl,
    sessions,
    onLogoutOthers,
    onSaveName,
    onUploadAvatar,
    onRemoveAvatar,
  } = useDuviCoreAdminSettingsPage();

  return (
    <DuviCoreAdminAppShell
      title="Settings"
      subtitle="Your account, security and appearance"
      breadcrumbs={["Settings"]}
      activeMenuItem=""
    >
      <div data-testid={DuviSharedAdminTestIds.settingsPage}>
        <DuviSharedAdminUserSettings
          name={name}
          email={email}
          avatarUrl={avatarUrl}
          sessions={sessions}
          onLogoutOthers={onLogoutOthers}
          onSaveName={onSaveName}
          onUploadAvatar={onUploadAvatar}
          onRemoveAvatar={onRemoveAvatar}
        />
      </div>
    </DuviCoreAdminAppShell>
  );
}
